import {Directive, ElementRef, Input, Renderer, OnChanges, SimpleChanges, AfterViewInit, Output, EventEmitter} from '@angular/core';
import {NgModel} from "@angular/forms";

declare var jQuery:any;



@Directive({
    selector: '.datepicker, [datepicker]',
    providers: [NgModel],
})
export class DatepickerDirective implements AfterViewInit {

    @Input() datepicker: any = {};

    @Input() ngModel;
    @Output() ngModelChange = new EventEmitter();


    constructor(public el: ElementRef, public renderer: Renderer, private model:NgModel) {
    }

    ngOnInit(){
        this.model.valueChanges.subscribe((value) => {
            jQuery(this.el.nativeElement).datepicker('update');
        });
    }
    
    ngAfterViewInit() {
        jQuery(this.el.nativeElement).datepicker(this.datepicker);


        jQuery(this.el.nativeElement).selectpicker()
            .on('changeDate', (e) => {
                this.ngModelChange.emit(jQuery(this.el.nativeElement).val());
            });

    }
}


// WEBPACK FOOTER //
// ./src/app/directives/datepicker/datepicker.directive.ts